<template>
  <v-dialog v-model="dialogopenwebsite" persistent max-width="500px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
        <v-container grid-list-md>
          <v-layout wrap >
            <v-flex sm12 md12 lg12 xl12>
              <div v-if="type=='friend' && status=='success'">
                <img :src="pictureFriend" class="pictureProfile" @click="openPictureProfile()">
                <br>
                <div class="CSChatThai" style="text-align:center">
                  <h3>{{result.name}}</h3>
                 {{result.status}}
                </div>
                <br>
                <v-btn @click="chat(result.tokenroom)" v-if="relation=='friend'" class="chatbtn">
                  {{$t('AnswerQuestion.chat')}}
                </v-btn>
                <v-btn @click="AcceptReq(result.tokenuser)" v-else-if="relation=='request'" class="chatbtn">
                  {{$t('AnswerQuestion.acceptFriend')}}
                </v-btn>
                <v-btn @click="RemoveReq(result.tokenuser)" v-else-if="relation=='sendrequest'" class="canclebtn">
                  {{$t('AnswerQuestion.cancelRequest')}}
                </v-btn>
                <v-btn @click="closeDialog()" v-else-if="relation=='self'" class="chatbtn">
                  {{$t('AnswerQuestion.ok')}}
                </v-btn>
                <!-- <v-btn @click="AddFriend(result.tokenuser)" v-else-if="relation=='unknown' || relation=='unfriend'" class="chatbtn">
                  {{$t('AnswerQuestion.addFriend')}}
                </v-btn> -->
                <v-btn @click="AddFriendCollab(result)" v-else-if="relation=='unknown' || relation=='unfriend'" class="chatbtn">
                  {{$t('AnswerQuestion.addFriend')}}
                </v-btn>
                <v-btn @click="unblock(result.tokenuser, result.tokenroom)" v-else-if="relation=='block'"class="canclebtn">
                  {{$t('AnswerQuestion.unblock')}}
                </v-btn>
              </div>
              <div v-else-if="type=='group' && status=='success'">
                 <img :src="pictureGroup" class="pictureProfile" @click="openPictureGroup()">
                <div class="CSChatThai" style="text-align:center">
                <h3>{{result.name}}</h3>
              </div>
              <br>
              <v-btn @click="AcceptGroup(result.group_id)" class="chatbtn" v-if="result.state != 'active'">
                {{$t('AnswerQuestion.joinGroup')}}
              </v-btn>
              <v-btn @click="chat(result.tokenroom)" class="chatbtn" v-else>
                {{$t('AnswerQuestion.chat')}}
              </v-btn>
              </div>
              <div v-else-if="status=='loading'">
                <v-progress-linear
              color="light-blue darken-4"
              indeterminate
              height="6"
            ></v-progress-linear>
              </div>
              <div class="CSChatThai" style="text-align:center" v-else>
                <h3>ไม่พบข้อมูล</h3>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
  </v-dialog>
</template>
<script>
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'

export default {
  props: {'dialogopenwebsite': false, id: '', type: ''},
  data: () => ({
    token: '',
    result: {},
    relation: '',
    pictureFriend: '',
    pictureGroup: '',
    status: 'loading',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: ''
  }),
  components: {
    ShowImageProfileDialog
  },
  watch: {
    dialogopenwebsite () {
      // console.log(this.dialogopenwebsite)
      if (this.dialogopenwebsite) {
        if (this.type=='friend') {
          this.status = 'loading'
          this.axios.post(process.env.APImanage + '/searchtokenuser', {
            tokenuser: this.token,
            tokenfriend: this.id
          }).then((response) => {
            // console.log(response.data)
            this.status = response.data.status
            if (response.data.status === 'success') {
              this.relation = response.data.relation
              this.result = response.data.user
              if (this.result.profilepicture === '') {
                if (this.result.type === 'business') {
                  this.pictureFriend = '/static/img/default_profile/business-white.png'
                } else if (this.result.type === 'bot') {
                  this.pictureFriend = '/static/img/default_profile/bot-white.png'
                } else {
                  this.pictureFriend = '/static/img/default_profile/man-white.png'
                }
              } else {
                this.pictureFriend = this.result.profilepicture
              }
            }
          })
        } else if (this.type=='group') {
          this.status = 'loading'
          this.axios.post(process.env.APImanage + '/getgroup', {
            tokenuser: this.token,
            group_id: this.id
          }).then((response) => {
            // console.log(response.data)
            this.status = response.data.status
            if (response.data.status === 'success') {
              this.result = response.data.group
              if (this.result.picture === '') {
                this.pictureGroup = '/static/img/default_profile/group-white.png'
              } else {
                this.pictureGroup = this.result.picture
              }
            }
          })
        }
      }
    }
  },
  methods: {
    openPictureProfile () {
      this.pathpicture = this.result.profilepicture
      this.typepathpicture = this.result.type
      this.dialogshowimage_profile = true
    },
    openPictureGroup () {
      this.pathpicture = this.result.picture
      this.typepathpicture = 'group'
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    AcceptGroup (group_id) {
      this.axios.post(process.env.APImanage + '/joingroup', {
        group_id: group_id,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response)
        this.socketactive_group = {timestamp: '', groupid: group_id, tokenuser: this.token}
        this.closeDialog()
      })
    },
    chat (tokenroom) {
      this.$router.push('/chat/room/' + tokenroom)
      this.closeDialog()
    },
    AcceptReq (tokenFriend) {
      this.axios.post(process.env.APImanage + '/acceptfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data.tokenroom)
        if (response.data['status'] === 'success') {
          this.relation = 'friend'
          this.result['tokenroom'] = response.data.tokenroom
          // this.closeDialog()
        }
      })
    },
    RemoveReq (tokenFriend) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          this.relation = 'unknown'
          // this.closeDialog()
        }
      })
    },
    AddFriend (tokenFriend) {
      this.axios.post(process.env.APInew_addfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'sendrequest'
          this.$store.dispatch('sendRequest', tokenFriend)
          // this.closeDialog()
        } else {
          alert('Error!!!')
        }
      })
    },
    AddFriendCollab (item) {
      // console.log(item)
      // console.log(index)
      this.axios.post(process.env.APIgo_api + `/v1/add-friend-accept`, {tokenfriend: item.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          // this.loading = false
          // if (state === 'true') {
          //   this.chat(response.data.tokenroom)
          // } else {
          //   this.relation = 'friend'
          // }
          this.relation = 'friend'
          this.result.tokenroom = response.data.tokenroom
        } else {
          // this.loading = false
          this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
        }
      }).catch(error => {
        console.log(error)
        // this.loading = false
        this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
      })
    },
    unblock (tokenFriend, tokenroom) {
      this.axios.post(process.env.APImanage + '/unblockfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token,
        tokenroom: tokenroom
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.$swal(
            'Unblocked!',
            this.$t('Alert.Success.unblock'),
            'success'
          )
          this.relation = 'friend'
          this.result['state'] = 'friend'
          this.result['event'] = 'unblock_friend'
          this.block_friend = this.result
        }
      })
    },
    findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    closeDialog () {
      this.status = 'loading'
      this.result = {}
      this.relation = ''
      this.pictureFriend = ''
      this.pictureGroup = ''
      this.$emit('closeDialog', false)
    }
  },
  computed: {
    ...sync('*')
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // console.log(this.tokenuserQR)
  }
}
</script>
<style type="text/css" scoped>
.chatbtn {
  display: flex;
  border-radius: 10px;
  margin: auto;
  margin-top: 5px;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.canclebtn {
  display: flex;
  border-radius: 10px;
  margin: auto;
  margin-top: 5px;
  background: #ff5252 !important;
  color: white !important;
  text-transform: none;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.pictureProfile {
  border: 1px solid #1a222b;
  display: flex;
  margin: auto;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  object-position: 50% 0;
  cursor: pointer;
}
/*.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
  color: #5ed1ff !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/settings/Openwebsite.vue